import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

// O modeloRequerimento 217 não tem TelefoneResidencial nem TelefoneCelular —
// tirados daqui pra não gerar warning de campoNome inexistente a cada envio
// (ver resolverCamposTexto em dadosRequerimentoService.js).
const CAMPOS_TELEFONE = ['TelefoneResidencial', 'TelefoneCelular'];

const pedidoCertidaoNaoInscritoConfig = {
  id: 'pedido_certidao_nao_inscrito',
  nome: 'Certidão de Não Inscrito',
  descricao: 'Solicitação de Certidão de Não Inscrito junto à OAB/MS',
  icon: 'FaCertificate',

  documentConfig: {
    required: []
  },

  paymentConfig: {
    amount: 27.00
  },

  // modeloRequerimento/tiposAssunto/tipoLancamentoId: códigos externos (APIs de
  // Protocolo e Títulos) informados diretamente pelo dono do catálogo, não
  // deduzidos nem reaproveitados de outro pedido. Este modelo não tem
  // tipoPedido (confirmado pelo dono do catálogo) — como o pedido tem taxa, ele
  // nunca passa por /finalizar, o único endpoint que exige tipoPedido.
  protocoloConfig: {
    modeloRequerimento: '217',
    tiposAssunto: '353'
  },

  tituloConfig: {
    tipoLancamentoId: 45,
    enderecoOrigem: 'residencial'
  },

  // O modelo 217 também tem DivlgacaoWebComercial, EnderecoCorreio e
  // CorrespondenciaComercial — de propósito NÃO mapeados por enquanto (decisão
  // do dono do catálogo). `informacoesAdicionais` segue a mesma regra dos
  // pedidos de Inteiro Teor: só de UI, aparece no Resumo do Requerimento em PDF.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    {
      ...DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL,
      campos: DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL.campos.filter((c) => !CAMPOS_TELEFONE.includes(c.campoNome))
    }
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true, comEnderecoEmSeuNome: false }),
    {
      id: 'informacoes_adicionais',
      title: 'Informações Adicionais',
      sections: [
        {
          title: 'Informações Adicionais',
          fields: [
            {
              type: 'textarea',
              name: 'informacoesAdicionais',
              label: 'Informações adicionais (opcional)',
              required: false,
              placeholder: 'Se desejar, escreva aqui informações que possam ajudar na geração da certidão',
              rows: 4
            }
          ]
        }
      ]
    },
    termosStep()
  ]
};

export default pedidoCertidaoNaoInscritoConfig;
